<template>
  <div class="header-options__wrapper">
    <div class="header-options flex justify-between" :class="{'flex-row-reverse': iconPosition === 'right'}">
      <div class="flex items-center w-1/5" :class="{'pl-3 justify-start': iconPosition === 'left', 'pr-3 justify-end': iconPosition === 'right'}">
        <IconButton @click="$emit('close')">
          <TagIcon
            :icon="icon"
            color="mono-black"
          />
        </IconButton>
      </div>

      <div class="flex items-center justify-center w-3/5">
        <h5 class="font-semibold text-init">
          {{ title }}
        </h5>
      </div>

      <div class="flex items-center justify-start w-1/5" :class="{invisible: !actionLabel}">
        <BaseButton
          class="ml-2"
          color="inverse"
          @click="$emit('action')"
        >
          {{ actionLabel }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
// component it's used in:
// * MoreOptions - filters search popup (icon on the right)
// * MobilePopover - accounts settings UC (icon on the left)

import ChevronLeftIcon from '@tagvenue/icons/24/bold/arrows/chevron-left.svg';
import CloseIcon from '@tagvenue/icons/24/line/general/x-close.svg';

import TagIcon from '@/components/TagIcon.vue';

import BaseButton from '../Buttons/BaseButton.vue';
import IconButton from '../Buttons/IconButton.vue';

export default {
  name: 'Header',
  components: { BaseButton, TagIcon, IconButton },
  props: {
    actionLabel: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    iconName: {
      type: String,
      default: 'close-icon',
    },
    iconPosition: {
      type: String,
      default: 'right',
    },
  },
  data() {
    return {
      CloseIcon,
    };
  },
  computed: {
    icon() {
      if (this.iconName === 'chevron-left') {
        return ChevronLeftIcon;
      }
      return CloseIcon;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@sass/design-system/variables" as ds-variables;

$header-height: 64px;

.header-options__wrapper {
  height: $header-height;
}

.header-options {
  height: $header-height;
  width: 100%;
  border-bottom: 1px solid ds-variables.$grey-300;
  background: ds-variables.$white;
  top: 0;
  position: fixed;
  z-index: 10;
  border-radius: 8px 8px 0 0;
}
</style>
